module.exports = __webpack_public_path__ + "static/img/open.03ac3e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/open.png
// module id = iFAN
// module chunks = 1